import { RxConversationAPI } from '@driftt/dapper'

export const api = {
  requestBulkClose({ inboxId, conversationIds }) {
    return RxConversationAPI
      .post(`/conversations/update/close`, {
        inboxId,
        conversationIds,
        status: "CLOSED",
      })
      .checkStatus()
  },
}

export default api



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/bulkUpdate/api.js